import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const navLinkClass =
  'nav-link-animated glass-button rounded-full px-5 py-2.5 text-sm tracking-wide font-display font-medium ' +
  'hover:scale-[1.04] active:scale-[0.98] ' +
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-200/90';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="glass-navbar mx-4 mt-2 sm:mt-3 sm:mx-6 max-w-7xl lg:mx-auto shadow-frutiger-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex min-h-[3.75rem] items-center justify-between gap-4 py-2.5">
          <Link
            to="/"
            className="nav-logo-animated group flex min-w-0 items-center gap-2.5 rounded-2xl border border-white/45 bg-gradient-to-r from-white/30 to-sky-200/25 px-3 py-2 backdrop-blur-md shadow-[inset_0_1px_0_rgba(255,255,255,0.55),0_6px_20px_rgba(0,80,140,0.15)] transition-transform hover:scale-[1.02] active:scale-[0.98] md:px-4"
          >
            <span
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/50 bg-gradient-to-b from-white/55 to-sky-300/35 shadow-aero-bubble"
              aria-hidden
            >
              <svg className="h-6 w-6 text-sky-800/85" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.5c2.48 0 4.5-2.02 4.5-4.5 0-2.64-2.05-4.78-4.65-4.96z" />
              </svg>
            </span>
            <span className="font-display truncate text-sm font-semibold tracking-wide text-sky-950/90 drop-shadow-sm">
              Kuzmin
            </span>
          </Link>

          <div className="flex items-center gap-2">
            <div className="nav-desktop hidden md:flex md:items-center md:gap-3 lg:gap-5">
              <Link to="/" className={navLinkClass}>
                Home
              </Link>
              <Link to="/blog" className={navLinkClass}>
                Blog
              </Link>
              <Link to="/resume" className={navLinkClass}>
                Resume
              </Link>
            </div>
            <button
              type="button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="nav-logo-animated glass-button md:hidden rounded-xl p-2.5 transition-all duration-300 hover:scale-105 active:scale-95"
              aria-expanded={isMenuOpen}
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="nav-mobile md:hidden border-t border-sky-400/35 pb-5 pt-4">
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className={`${navLinkClass} justify-center text-center`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/blog"
                className={`${navLinkClass} justify-center text-center`}
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link
                to="/resume"
                className={`${navLinkClass} justify-center text-center`}
                onClick={() => setIsMenuOpen(false)}
              >
                Resume
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
